export const countryFlags = {
  'Turkey': '🇹🇷',
  'Germany': '🇩🇪',
  'United States': '🇺🇸',
  'United Kingdom': '🇬🇧',
  'France': '🇫🇷',
  'Canada': '🇨🇦',
  'Netherlands': '🇳🇱',
  'Australia': '🇦🇺',
  'Sweden': '🇸🇪',
  'Switzerland': '🇨🇭',
  'Italy': '🇮🇹',
  'Spain': '🇪🇸',
  'Poland': '🇵🇱',
  'Brazil': '🇧🇷',
  'India': '🇮🇳',
  'Japan': '🇯🇵',
  'South Korea': '🇰🇷',
  'China': '🇨🇳',
  'Russia': '🇷🇺',
  'Norway': '🇳🇴',
  'Denmark': '🇩🇰',
  'Finland': '🇫🇮',
  'Belgium': '🇧🇪',
  'Austria': '🇦🇹',
  'Ireland': '🇮🇪',
  'Portugal': '🇵🇹',
  'Greece': '🇬🇷',
  'Czech Republic': '🇨🇿',
  'Hungary': '🇭🇺',
  'Romania': '🇷🇴',
  'Bulgaria': '🇧🇬',
  'Croatia': '🇭🇷',
  'Slovakia': '🇸🇰',
  'Slovenia': '🇸🇮',
  'Lithuania': '🇱🇹',
  'Latvia': '🇱🇻',
  'Estonia': '🇪🇪',
  'Ukraine': '🇺🇦',
  'Belarus': '🇧🇾',
  'Serbia': '🇷🇸',
  'Bosnia and Herzegovina': '🇧🇦',
  'Montenegro': '🇲🇪',
  'North Macedonia': '🇲🇰',
  'Albania': '🇦🇱',
  'Moldova': '🇲🇩',
  'Luxembourg': '🇱🇺',
  'Malta': '🇲🇹',
  'Cyprus': '🇨🇾',
  'Iceland': '🇮🇸',
  'Liechtenstein': '🇱🇮',
  'Monaco': '🇲🇨',
  'San Marino': '🇸🇲',
  'Vatican City': '🇻🇦',
  'Andorra': '🇦🇩',
  'Israel': '🇮🇱',
  'Palestine': '🇵🇸',
  'Jordan': '🇯🇴',
  'Lebanon': '🇱🇧',
  'Syria': '🇸🇾',
  'Iraq': '🇮🇶',
  'Iran': '🇮🇷',
  'Saudi Arabia': '🇸🇦',
  'UAE': '🇦🇪',
  'Kuwait': '🇰🇼',
  'Qatar': '🇶🇦',
  'Bahrain': '🇧🇭',
  'Oman': '🇴🇲',
  'Yemen': '🇾🇪',
  'Egypt': '🇪🇬',
  'Libya': '��🇾',
  'Tunisia': '🇹🇳',
  'Algeria': '🇩🇿',
  'Morocco': '🇲🇦',
  'Sudan': '🇸🇩',
  'South Sudan': '🇸🇸',
  'Ethiopia': '🇪🇹',
  'Kenya': '🇰🇪',
  'Uganda': '🇺🇬',
  'Tanzania': '🇹🇿',
  'Rwanda': '🇷🇼',
  'Burundi': '🇧🇮',
  'Somalia': '🇸🇴',
  'Djibouti': '🇩🇯',
  'Eritrea': '🇪🇷',
  'South Africa': '🇿🇦',
  'Nigeria': '🇳🇬',
  'Ghana': '🇬🇭',
  'Ivory Coast': '🇨🇮',
  'Senegal': '🇸🇳',
  'Mali': '🇲🇱',
  'Burkina Faso': '🇧🇫',
  'Niger': '🇳🇪',
  'Chad': '🇹🇩',
  'Central African Republic': '🇨🇫',
  'Cameroon': '🇨🇲',
  'Equatorial Guinea': '🇬🇶',
  'Gabon': '🇬🇦',
  'Republic of the Congo': '🇨🇬',
  'Democratic Republic of the Congo': '🇨🇩',
  'Angola': '🇦🇴',
  'Zambia': '🇿🇲',
  'Zimbabwe': '🇿🇼',
  'Botswana': '🇧🇼',
  'Namibia': '🇳🇦',
  'Lesotho': '🇱🇸',
  'Eswatini': '🇸🇿',
  'Madagascar': '🇲🇬',
  'Mauritius': '🇲🇺',
  'Seychelles': '🇸🇨',
  'Comoros': '🇰🇲',
  'Cape Verde': '🇨🇻',
  'Guinea-Bissau': '🇬🇼',
  'Guinea': '🇬🇳',
  'Sierra Leone': '🇸🇱',
  'Liberia': '🇱🇷',
  'Togo': '🇹🇬',
  'Benin': '🇧🇯',
  'Mauritania': '🇲🇷',
  'Gambia': '🇬🇲',
  'Argentina': '🇦🇷',
  'Chile': '🇨🇱',
  'Uruguay': '🇺🇾',
  'Paraguay': '🇵🇾',
  'Bolivia': '🇧🇴',
  'Peru': '🇵🇪',
  'Ecuador': '🇪🇨',
  'Colombia': '🇨🇴',
  'Venezuela': '🇻🇪',
  'Guyana': '🇬🇾',
  'Suriname': '🇸🇷',
  'French Guiana': '🇬🇫',
  'Mexico': '🇲🇽',
  'Guatemala': '🇬🇹',
  'Belize': '🇧🇿',
  'El Salvador': '🇸🇻',
  'Honduras': '🇭🇳',
  'Nicaragua': '🇳🇮',
  'Costa Rica': '🇨🇷',
  'Panama': '🇵🇦',
  'Cuba': '🇨🇺',
  'Jamaica': '🇯🇲',
  'Haiti': '🇭🇹',
  'Dominican Republic': '🇩🇴',
  'Puerto Rico': '🇵🇷',
  'Trinidad and Tobago': '🇹🇹',
  'Barbados': '🇧🇧',
  'Saint Vincent and the Grenadines': '🇻🇨',
  'Grenada': '🇬🇩',
  'Saint Lucia': '🇱🇨',
  'Dominica': '🇩🇲',
  'Antigua and Barbuda': '🇦🇬',
  'Saint Kitts and Nevis': '🇰🇳',
  'Bahamas': '🇧🇸',
  'Afghanistan': '🇦🇫',
  'Pakistan': '🇵🇰',
  'Bangladesh': '🇧🇩',
  'Sri Lanka': '🇱🇰',
  'Maldives': '🇲🇻',
  'Nepal': '🇳🇵',
  'Bhutan': '🇧🇹',
  'Myanmar': '🇲🇲',
  'Thailand': '🇹🇭',
  'Laos': '🇱🇦',
  'Vietnam': '🇻🇳',
  'Cambodia': '🇰🇭',
  'Malaysia': '🇲🇾',
  'Singapore': '🇸🇬',
  'Indonesia': '🇮🇩',
  'Brunei': '🇧🇳',
  'Philippines': '🇵🇭',
  'East Timor': '🇹🇱',
  'Papua New Guinea': '🇵🇬',
  'Solomon Islands': '🇸🇧',
  'Vanuatu': '🇻🇺',
  'Fiji': '🇫🇯',
  'New Caledonia': '🇳🇨',
  'Samoa': '🇼🇸',
  'Tonga': '🇹🇴',
  'Tuvalu': '🇹🇻',
  'Kiribati': '🇰🇮',
  'Nauru': '🇳🇷',
  'Palau': '🇵🇼',
  'Marshall Islands': '🇲🇭',
  'Micronesia': '🇫🇲',
  'New Zealand': '🇳🇿',
  'Mongolia': '🇲🇳',
  'Kazakhstan': '🇰🇿',
  'Uzbekistan': '🇺🇿',
  'Turkmenistan': '🇹🇲',
  'Kyrgyzstan': '🇰🇬',
  'Tajikistan': '🇹🇯',
  'Azerbaijan': '🇦🇿',
  'Armenia': '🇦🇲',
  'Georgia': '🇬🇪',
  'North Korea': '🇰🇵'
};

export const LOCATION_COORDINATES = {
  'istanbul': { lat: 41.0082, lng: 28.9784 },
  'ankara': { lat: 39.9334, lng: 32.8597 },
  'izmir': { lat: 38.4192, lng: 27.1287 },
  'london': { lat: 51.5074, lng: -0.1278 },
  'new york': { lat: 40.7128, lng: -74.0060 },
  'san francisco': { lat: 37.7749, lng: -122.4194 },
  'los angeles': { lat: 34.0522, lng: -118.2437 },
  'berlin': { lat: 52.5200, lng: 13.4050 },
  'paris': { lat: 48.8566, lng: 2.3522 },
  'tokyo': { lat: 35.6762, lng: 139.6503 },
  'seoul': { lat: 37.5665, lng: 126.9780 },
  'beijing': { lat: 39.9042, lng: 116.4074 },
  'shanghai': { lat: 31.2304, lng: 121.4737 },
  'mumbai': { lat: 19.0760, lng: 72.8777 },
  'delhi': { lat: 28.7041, lng: 77.1025 },
  'bangalore': { lat: 12.9716, lng: 77.5946 },
  'sydney': { lat: -33.8688, lng: 151.2093 },
  'melbourne': { lat: -37.8136, lng: 144.9631 },
  'toronto': { lat: 43.6532, lng: -79.3832 },
  'vancouver': { lat: 49.2827, lng: -123.1207 },
  'moscow': { lat: 55.7558, lng: 37.6176 },
  'amsterdam': { lat: 52.3676, lng: 4.9041 },
  'zurich': { lat: 47.3769, lng: 8.5417 },
  'singapore': { lat: 1.3521, lng: 103.8198 },
  'hong kong': { lat: 22.3193, lng: 114.1694 },
  'dubai': { lat: 25.2048, lng: 55.2708 },
  'cairo': { lat: 30.0444, lng: 31.2357 },
  'cape town': { lat: -33.9249, lng: 18.4241 },
  'sao paulo': { lat: -23.5505, lng: -46.6333 },
  'rio de janeiro': { lat: -22.9068, lng: -43.1729 },
  'mexico city': { lat: 19.4326, lng: -99.1332 },
  'buenos aires': { lat: -34.6118, lng: -58.3960 },
  'lima': { lat: -12.0464, lng: -77.0428 },
  'bogota': { lat: 4.7110, lng: -74.0721 },
  'santiago': { lat: -33.4489, lng: -70.6693 },
  'lisbon': { lat: 38.7223, lng: -9.1393 },
  'madrid': { lat: 40.4168, lng: -3.7038 },
  'barcelona': { lat: 41.3851, lng: 2.1734 },
  'rome': { lat: 41.9028, lng: 12.4964 },
  'milan': { lat: 45.4642, lng: 9.1900 },
  'vienna': { lat: 48.2082, lng: 16.3738 },
  'warsaw': { lat: 52.2297, lng: 21.0122 },
  'prague': { lat: 50.0755, lng: 14.4378 },
  'budapest': { lat: 47.4979, lng: 19.0402 },
  'stockholm': { lat: 59.3293, lng: 18.0686 },
  'copenhagen': { lat: 55.6761, lng: 12.5683 },
  'oslo': { lat: 59.9139, lng: 10.7522 },
  'helsinki': { lat: 60.1699, lng: 24.9384 },
  'athens': { lat: 37.9838, lng: 23.7275 },
  'tel aviv': { lat: 32.0853, lng: 34.7818 },
  'jakarta': { lat: -6.2088, lng: 106.8456 },
  'manila': { lat: 14.5995, lng: 120.9842 },
  'bangkok': { lat: 13.7563, lng: 100.5018 },
  'kuala lumpur': { lat: 3.1390, lng: 101.6869 },
  'ho chi minh city': { lat: 10.8231, lng: 106.6297 },
  'hanoi': { lat: 21.0285, lng: 105.8542 },
  'chicago': { lat: 41.8781, lng: -87.6298 },
  'boston': { lat: 42.3601, lng: -71.0589 },
  'seattle': { lat: 47.6062, lng: -122.3321 },
  'austin': { lat: 30.2672, lng: -97.7431 },
  'denver': { lat: 39.7392, lng: -104.9903 },
  'miami': { lat: 25.7617, lng: -80.1918 },
  'atlanta': { lat: 33.7490, lng: -84.3880 },
  'philadelphia': { lat: 39.9526, lng: -75.1652 },
  'phoenix': { lat: 33.4484, lng: -112.0740 },
  'houston': { lat: 29.7604, lng: -95.3698 },
  'dallas': { lat: 32.7767, lng: -96.7970 },
  'san diego': { lat: 32.7157, lng: -117.1611 },
  'portland': { lat: 45.5152, lng: -122.6784 },
  'las vegas': { lat: 36.1699, lng: -115.1398 },
  'montreal': { lat: 45.5017, lng: -73.5673 },
  'calgary': { lat: 51.0447, lng: -114.0719 },
  'ottawa': { lat: 45.4215, lng: -75.6972 },
  'edmonton': { lat: 53.5461, lng: -113.4938 },
  'quebec': { lat: 46.8139, lng: -71.2080 },
  'halifax': { lat: 44.6488, lng: -63.5752 },
  'winnipeg': { lat: 49.8951, lng: -97.1384 },

  'turkey': { lat: 39.9334, lng: 32.8597 }, // Ankara
  'germany': { lat: 52.5200, lng: 13.4050 }, // Berlin
  'france': { lat: 48.8566, lng: 2.3522 }, // Paris
  'united kingdom': { lat: 51.5074, lng: -0.1278 }, // London
  'uk': { lat: 51.5074, lng: -0.1278 }, // London
  'united states': { lat: 39.8283, lng: -98.5795 }, // Geographic center
  'usa': { lat: 39.8283, lng: -98.5795 }, // Geographic center
  'canada': { lat: 56.1304, lng: -106.3468 }, // Geographic center
  'australia': { lat: -25.2744, lng: 133.7751 }, // Geographic center
  'japan': { lat: 36.2048, lng: 138.2529 }, // Geographic center
  'south korea': { lat: 35.9078, lng: 127.7669 }, // Geographic center
  'china': { lat: 35.8617, lng: 104.1954 }, // Geographic center
  'india': { lat: 20.5937, lng: 78.9629 }, // Geographic center
  'brazil': { lat: -14.2350, lng: -51.9253 }, // Geographic center
  'russia': { lat: 61.5240, lng: 105.3188 }, // Geographic center
  'netherlands': { lat: 52.1326, lng: 5.2913 }, // Geographic center
  'spain': { lat: 40.4637, lng: -3.7492 }, // Geographic center
  'italy': { lat: 41.8719, lng: 12.5674 }, // Geographic center
  'poland': { lat: 51.9194, lng: 19.1451 }, // Geographic center
  'mexico': { lat: 23.6345, lng: -102.5528 }, // Geographic center
  'argentina': { lat: -38.4161, lng: -63.6167 }, // Geographic center
  'south africa': { lat: -30.5595, lng: 22.9375 }, // Geographic center
  'israel': { lat: 31.0461, lng: 34.8516 }, // Geographic center
  'malaysia': { lat: 4.2105, lng: 101.9758 }, // Geographic center
  'thailand': { lat: 15.8700, lng: 100.9925 }, // Geographic center
  'indonesia': { lat: -0.7893, lng: 113.9213 }, // Geographic center
  'philippines': { lat: 12.8797, lng: 121.7740 }, // Geographic center
  'vietnam': { lat: 14.0583, lng: 108.2772 }, // Geographic center
  'egypt': { lat: 26.8206, lng: 30.8025 }, // Geographic center
  'nigeria': { lat: 9.0820, lng: 8.6753 }, // Geographic center
  'kenya': { lat: -0.0236, lng: 37.9062 }, // Geographic center
  'morocco': { lat: 31.7917, lng: -7.0926 }, // Geographic center
  'algeria': { lat: 28.0339, lng: 1.6596 }, // Geographic center
  'tunisia': { lat: 33.8869, lng: 9.5375 }, // Geographic center
  'iran': { lat: 32.4279, lng: 53.6880 }, // Geographic center
  'iraq': { lat: 33.2232, lng: 43.6793 }, // Geographic center
  'saudi arabia': { lat: 23.8859, lng: 45.0792 }, // Geographic center
  'uae': { lat: 23.4241, lng: 53.8478 }, // Geographic center
  'jordan': { lat: 30.5852, lng: 36.2384 }, // Geographic center
  'lebanon': { lat: 33.8547, lng: 35.8623 }, // Geographic center
  'syria': { lat: 34.8021, lng: 38.9968 }, // Geographic center
  'ukraine': { lat: 48.3794, lng: 31.1656 }, // Geographic center
  'belarus': { lat: 53.7098, lng: 27.9534 }, // Geographic center
  'romania': { lat: 45.9432, lng: 24.9668 }, // Geographic center
  'bulgaria': { lat: 42.7339, lng: 25.4858 }, // Geographic center
  'greece': { lat: 39.0742, lng: 21.8243 }, // Geographic center
  'portugal': { lat: 39.3999, lng: -8.2245 }, // Geographic center
  'norway': { lat: 60.4720, lng: 8.4689 }, // Geographic center
  'sweden': { lat: 60.1282, lng: 18.6435 }, // Geographic center
  'finland': { lat: 61.9241, lng: 25.7482 }, // Geographic center
  'denmark': { lat: 56.2639, lng: 9.5018 }, // Geographic center
  'belgium': { lat: 50.5039, lng: 4.4699 }, // Geographic center
  'austria': { lat: 47.5162, lng: 14.5501 }, // Geographic center
  'switzerland': { lat: 46.8182, lng: 8.2275 }, // Geographic center
  'czech republic': { lat: 49.8175, lng: 15.4730 }, // Geographic center
  'slovakia': { lat: 48.6690, lng: 19.6990 }, // Geographic center
  'hungary': { lat: 47.1625, lng: 19.5033 }, // Geographic center
  'croatia': { lat: 45.1000, lng: 15.2000 }, // Geographic center
  'serbia': { lat: 44.0165, lng: 21.0059 }, // Geographic center
  'bosnia and herzegovina': { lat: 43.9159, lng: 17.6791 }, // Geographic center
  'montenegro': { lat: 42.7087, lng: 19.3744 }, // Geographic center
  'north macedonia': { lat: 41.6086, lng: 21.7453 }, // Geographic center
  'albania': { lat: 41.1533, lng: 20.1683 }, // Geographic center
  'slovenia': { lat: 46.1512, lng: 14.9955 }, // Geographic center
  'estonia': { lat: 58.5953, lng: 25.0136 }, // Geographic center
  'latvia': { lat: 56.8796, lng: 24.6032 }, // Geographic center
  'lithuania': { lat: 55.1694, lng: 23.8813 }, // Geographic center
};

export const CITY_TO_COUNTRY = {
  'istanbul': 'Turkey',
  'ankara': 'Turkey',
  'izmir': 'Turkey',
  'antalya': 'Turkey',
  'bursa': 'Turkey',

  'new york': 'United States',
  'san francisco': 'United States',
  'los angeles': 'United States',
  'chicago': 'United States',
  'boston': 'United States',
  'seattle': 'United States',
  'austin': 'United States',
  'denver': 'United States',
  'miami': 'United States',
  'atlanta': 'United States',
  'philadelphia': 'United States',
  'phoenix': 'United States',
  'houston': 'United States',
  'dallas': 'United States',
  'san diego': 'United States',
  'portland': 'United States',
  'las vegas': 'United States',
  'washington': 'United States',

  'london': 'United Kingdom',
  'manchester': 'United Kingdom',
  'birmingham': 'United Kingdom',
  'glasgow': 'United Kingdom',
  'edinburgh': 'United Kingdom',
  'liverpool': 'United Kingdom',

  'berlin': 'Germany',
  'munich': 'Germany',
  'hamburg': 'Germany',
  'cologne': 'Germany',
  'frankfurt': 'Germany',

  'paris': 'France',
  'marseille': 'France',
  'lyon': 'France',
  'toulouse': 'France',
  'nice': 'France',

  'toronto': 'Canada',
  'vancouver': 'Canada',
  'montreal': 'Canada',
  'calgary': 'Canada',
  'ottawa': 'Canada',
  'edmonton': 'Canada',
  'quebec': 'Canada',
  'halifax': 'Canada',
  'winnipeg': 'Canada',

  'tokyo': 'Japan',
  'osaka': 'Japan',
  'kyoto': 'Japan',
  'yokohama': 'Japan',
  'kobe': 'Japan',

  'seoul': 'South Korea',
  'busan': 'South Korea',
  'incheon': 'South Korea',
  'daegu': 'South Korea',

  'beijing': 'China',
  'shanghai': 'China',
  'guangzhou': 'China',
  'shenzhen': 'China',
  'chengdu': 'China',

  'mumbai': 'India',
  'delhi': 'India',
  'bangalore': 'India',
  'hyderabad': 'India',
  'chennai': 'India',
  'kolkata': 'India',
  'pune': 'India',

  'sydney': 'Australia',
  'melbourne': 'Australia',
  'brisbane': 'Australia',
  'perth': 'Australia',
  'adelaide': 'Australia',

  'sao paulo': 'Brazil',
  'rio de janeiro': 'Brazil',
  'brasilia': 'Brazil',
  'salvador': 'Brazil',
  'fortaleza': 'Brazil',

  'moscow': 'Russia',
  'amsterdam': 'Netherlands',
  'zurich': 'Switzerland',
  'singapore': 'Singapore',
  'hong kong': 'Hong Kong',
  'dubai': 'UAE',
  'cairo': 'Egypt',
  'cape town': 'South Africa',
  'mexico city': 'Mexico',
  'buenos aires': 'Argentina',
  'lima': 'Peru',
  'bogota': 'Colombia',
  'santiago': 'Chile',
  'lisbon': 'Portugal',
  'madrid': 'Spain',
  'barcelona': 'Spain',
  'rome': 'Italy',
  'milan': 'Italy',
  'vienna': 'Austria',
  'warsaw': 'Poland',
  'prague': 'Czech Republic',
  'budapest': 'Hungary',
  'stockholm': 'Sweden',
  'copenhagen': 'Denmark',
  'oslo': 'Norway',
  'helsinki': 'Finland',
  'athens': 'Greece',
  'tel aviv': 'Israel',
  'jakarta': 'Indonesia',
  'manila': 'Philippines',
  'bangkok': 'Thailand',
  'kuala lumpur': 'Malaysia',
  'ho chi minh city': 'Vietnam',
  'hanoi': 'Vietnam',
};

export const COUNTRY_DISPLAY_NAMES = {
  'Türkiye': 'Türkiye',
  'United States': 'Amerika Birleşik Devletleri',
  'United Kingdom': 'Birleşik Krallık',
  'Germany': 'Almanya',
  'France': 'Fransa',
  'Canada': 'Kanada',
  'Japan': 'Japonya',
  'South Korea': 'Güney Kore',
  'China': 'Çin',
  'India': 'Hindistan',
  'Australia': 'Avustralya',
  'Brazil': 'Brezilya',
  'Russia': 'Rusya',
  'Netherlands': 'Hollanda',
  'Switzerland': 'İsviçre',
  'Singapore': 'Singapur',
  'Hong Kong': 'Hong Kong',
  'UAE': 'Birleşik Arap Emirlikleri',
  'Egypt': 'Mısır',
  'South Africa': 'Güney Afrika',
  'Mexico': 'Meksika',
  'Argentina': 'Arjantin',
  'Peru': 'Peru',
  'Colombia': 'Kolombiya',
  'Chile': 'Şili',
  'Portugal': 'Portekiz',
  'Spain': 'İspanya',
  'Italy': 'İtalya',
  'Austria': 'Avusturya',
  'Poland': 'Polonya',
  'Czech Republic': 'Çek Cumhuriyeti',
  'Hungary': 'Macaristan',
  'Sweden': 'İsveç',
  'Denmark': 'Danimarka',
  'Norway': 'Norveç',
  'Finland': 'Finlandiya',
  'Greece': 'Yunanistan',
  'Israel': 'İsrail',
  'Indonesia': 'Endonezya',
  'Philippines': 'Filipinler',
  'Thailand': 'Tayland',
  'Malaysia': 'Malezya',
  'Vietnam': 'Vietnam',
};

export function getLocationCoordinates(location) {
  if (!location || typeof location !== 'string') {
    return null;
  }

  const normalizedLocation = location.toLowerCase().trim();

  if (LOCATION_COORDINATES[normalizedLocation]) {
    return LOCATION_COORDINATES[normalizedLocation];
  }

  for (const [key, coords] of Object.entries(LOCATION_COORDINATES)) {
    if (normalizedLocation.includes(key) || key.includes(normalizedLocation)) {
      return coords;
    }
  }

  const variations = {
    'ny': 'new york',
    'nyc': 'new york',
    'sf': 'san francisco',
    'la': 'los angeles',
    'dc': { lat: 38.9072, lng: -77.0369 }, // Washington DC
  };

  if (variations[normalizedLocation]) {
    const variation = variations[normalizedLocation];
    if (typeof variation === 'string') {
      return LOCATION_COORDINATES[variation];
    }
    return variation;
  }

  return null;
}

export function getCountryFromLocation(location) {
  if (!location || typeof location !== 'string') {
    return null;
  }

  const normalizedLocation = location.toLowerCase().trim();

  for (const [key] of Object.entries(LOCATION_COORDINATES)) {
    if (key === normalizedLocation && !CITY_TO_COUNTRY[key]) {
      return location.split(' ').map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      ).join(' ');
    }
  }

  if (CITY_TO_COUNTRY[normalizedLocation]) {
    return CITY_TO_COUNTRY[normalizedLocation];
  }

  for (const [city, country] of Object.entries(CITY_TO_COUNTRY)) {
    if (normalizedLocation.includes(city) || city.includes(normalizedLocation)) {
      return country;
    }
  }

  const countryVariations = {
    'usa': 'United States',
    'us': 'United States',
    'america': 'United States',
    'uk': 'United Kingdom',
    'britain': 'United Kingdom',
    'england': 'United Kingdom',
    'uae': 'UAE',
    'south korea': 'South Korea',
    'korea': 'South Korea',
  };

  if (countryVariations[normalizedLocation]) {
    return countryVariations[normalizedLocation];
  }

  for (const [variation, country] of Object.entries(countryVariations)) {
    if (normalizedLocation.includes(variation)) {
      return country;
    }
  }

  return null;
}

export function processStargazersLocations(stargazersData) {
  const countryGroups = {};
  const colors = ['#06b6d4', '#3b82f6', '#6366f1', '#8b5cf6', '#ec4899', '#f59e0b'];

  stargazersData.forEach((stargazer) => {
    const profile = stargazer.detailed_profile || stargazer;
    let country = null;
    let coordinates = null;
    let locationSource = 'unknown';

    if (stargazer.processed_location?.country) {
      country = stargazer.processed_location.country;
      coordinates = getLocationCoordinates(country.toLowerCase());
      locationSource = stargazer.processed_location.method || 'firebase_processed';
    }
    else if (profile?.assignedLocation) {
      country = profile.assignedLocation.country;
      coordinates = {
        lat: profile.assignedLocation.coordinates[0],
        lng: profile.assignedLocation.coordinates[1]
      };
      locationSource = profile.assignedLocation.method;
    } else {
      const location = profile?.location;
      country = getCountryFromLocation(location);
      coordinates = getLocationCoordinates(location);
      locationSource = 'original';
    }

    if (country) {
      if (!countryGroups[country]) {
        countryGroups[country] = {
          country: country,
          users: [],
          count: 0,
          coordinates: coordinates
        };
      }

      countryGroups[country].users.push({
        id: profile.id,
        username: profile.login,
        name: profile.name || profile.login,
        location: profile.location,
        assignedLocation: profile.assignedLocation,
        processed_location: stargazer.processed_location,
        avatar_url: profile.avatar_url,
        public_repos: profile.public_repos,
        followers: profile.followers,
        bio: profile.bio,
        locationSource: locationSource
      });

      countryGroups[country].count++;
    }
  });

  const countries = [];
  let colorIndex = 0;

  for (const [countryName, countryData] of Object.entries(countryGroups)) {
    let coordinates = countryData.coordinates;
    if (!coordinates) {
      coordinates = getLocationCoordinates(countryName.toLowerCase());
    }

    if (coordinates) {
      countries.push({
        country: countryName,
        displayName: countryName, // Will be translated by i18n helper
        lat: coordinates.lat,
        lng: coordinates.lng,
        color: colors[colorIndex % colors.length],
        users: countryData.users,
        count: countryData.count,
      });
      colorIndex++;
    }
  }

  countries.sort((a, b) => b.count - a.count);

  return countries;
}

export function createGlobeArcs(countries, centerPoint = { lat: 41.0082, lng: 28.9784 }) {
  return countries.map((country, index) => ({
    order: index + 1,
    startLat: centerPoint.lat,
    startLng: centerPoint.lng,
    endLat: country.lat,
    endLng: country.lng,
    arcAlt: Math.random() * 0.4 + 0.1,
    color: country.color,
    countryData: country,
  }));
}